var CandidateProfileActionsModalController = /** @class */ (function () {
    function CandidateProfileActionsModalController(documentService) {
        this.documentService = documentService;
    }
    CandidateProfileActionsModalController.prototype.$onInit = function () {
        this.actionType = this.resolve.actionType;
        this.actionLabel = this.resolve.actionLabel;
        this.candidateId = this.resolve.candidateId;
        this.folder = this.resolve.folder;
        this.document = this.resolve.document;
        this.parentFolderName = this.resolve.parentFolderName;
        this.parentFolders = this.resolve.parentFolders;
        this.showUpload = this.resolve.showUpload;
        this.documents = this.resolve.documents;
        this.availableDocuments = this.resolve.availableDocuments;
        this.folders = this.resolve.folders;
        this.candidateJobMatchFolders = this.resolve.candidateJobMatchFolders;
        this.candidateDetails = this.resolve.candidateDetails;
        this.candidateType = this.resolve.candidateType;
        this.deleteDocumentPayload = this.resolve.deleteDocumentPayload;
        this.allFoldersList = this.resolve.allFoldersList;
        this.isSharedDocumentActionAvailable = this.resolve.isSharedDocumentActionAvailable;
        this.companiesToShareCandidateDocuments = this.resolve.companiesToShareCandidateDocuments;
        this.callbackObject = { callbackType: 'cancel', entity: {} };
        this.sourceScreen = this.resolve.sourceScreen;
        this.formalizeActivityPayload = this.resolve.formalizeActivityPayload;
        this._setCandidateDocumentViewUrl();
    };
    CandidateProfileActionsModalController.prototype.closeModal = function () {
        this.modalInstance.close(this.callbackObject);
    };
    CandidateProfileActionsModalController.prototype.dismissModal = function () {
        this.modalInstance.dismiss('cancel');
    };
    CandidateProfileActionsModalController.prototype.refresh = function (folder) {
        this.callbackObject.callbackType = 'refresh';
        if (folder) {
            this.callbackObject.entity = folder;
            this.closeModal();
        }
    };
    CandidateProfileActionsModalController.prototype.attachDocuments = function (documents) {
        this.callbackObject.callbackType = 'attachDocuments';
        this.callbackObject.entity = documents;
        this.closeModal();
    };
    CandidateProfileActionsModalController.prototype.onEmployeeAdded = function (employee) {
        this.modalInstance.close(employee);
    };
    CandidateProfileActionsModalController.prototype._setCandidateDocumentViewUrl = function () {
        if (this.document) {
            if (this.document.isJobMatchDocument) {
                this.documentViewUrl = this.document.link;
            }
            else {
                this.documentViewUrl = this.documentService.getCandidateDocumentReportUrl(this.document.id);
            }
        }
    };
    return CandidateProfileActionsModalController;
}());
CandidateProfileActionsModalController.$inject = ['documentService'];
// import * as TEMPLATE from './candidate-profile-actions-modal.html';
import * as TEMPLATE from 'raw-loader!./candidate-profile-actions-modal.html';
export var CandidateProfileActionsModalComponent = {
    selector: 'candidateProfileActionsModal',
    component: {
        bindings: {
            modalInstance: "<",
            resolve: "<"
        },
        controller: CandidateProfileActionsModalController,
        template: TEMPLATE.default
        // templateUrl: 'app/partials/missioncontrol/candidateprofile/candidateProfile/candidateProfileActionsModal/candidate-profile-actions-modal.html'
    }
};
//# sourceMappingURL=candidate-profile-actions-modal.component.js.map